export const SettingsPaths = {
	UsersIndex: {
		route: "/settings/users",
		path: "/settings/users",
	},
	UsersEdit: {
		route: "/settings/users/:id",
		path: (id: number) => `/settings/users/${id}`,
	},
	UsersRolesAdd: {
		route: "/settings/users/roles/add",
		path: () => "/settings/users/roles/add",
	},
	UsersRolesEdit: {
		route: "/settings/users/roles/edit",
		path: () => "/settings/users/roles/edit",
	},
	UsersRoles: {
		route: "/settings/users/roles",
		path: () => "/settings/users/roles",
	},
	UserDetail: {
		route: "/settings/profile/detail",
		path: "/settings/profile/detail",
	},
	VerticalSetupMarketSelect: {
		route: "/settings/vertical-setup",
		path: "/settings/vertical-setup",
	},
	VerticalSetupVerticalSelect: {
		route: "/settings/vertical-setup/:marketId",
		path: (marketId: number) => `/settings/vertical-setup/${marketId}`,
	},
	VerticalSetupSelect: {
		route: "/settings/vertical-setup/:marketId/:verticalId?",
		path: (marketId: number, verticalId?: number) =>
			`/settings/vertical-setup/${marketId}/${verticalId}`,
	},
	OrderSetup: {
		route: "/settings/vertical-setup/:marketId/:verticalId/order",
		path: (marketId: number, verticalId?: number) =>
			`/settings/vertical-setup/${marketId}/${verticalId}/order`,
	},
	OrderSetupEdit: {
		route:
			"/settings/vertical-setup/:marketId/:verticalId/order/:orderSetupId?",
		path: (marketId: number, verticalId?: number, orderSetupId?: number) =>
			`/settings/vertical-setup/${marketId}/${verticalId}/order/${orderSetupId}`,
	},
	GeneralSetup: {
		route: "/settings/vertical-setup/:marketId/:verticalId/general",
		path: (marketId: number, verticalId?: number) =>
			`/settings/vertical-setup/${marketId}/${verticalId}/general`,
	},
};
